import Vue from 'vue';
import Vuex from 'vuex';
const storeProto = Vuex.Store.prototype
if ( !storeProto.hasModule ) {
  const registerModuleOriginal = storeProto.registerModule

  function pathToKey(path) {
    return path instanceof Array ? path.join('/') : path
  }

  storeProto.registerModule = function(path, rawModule, opts) {
    if (!this._registeredModules) this._registeredModules = new Set()

    let pathKey = pathToKey(path)
    this._registeredModules.add(pathKey)

    return registerModuleOriginal.call(this, path, rawModule, opts)
  }

  storeProto.registerModuleOnce = function(path, rawModule, opts) {
    if (this.hasModule(path)) return false
    return this.registerModule.call(this, path, rawModule, opts)
  }

  storeProto.hasModule = function(path) {
    let pathKey = pathToKey(path)
    if (this._registeredModules) return this._registeredModules.has(pathKey)
    return false
  }
}
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    pageData: null,
    loading: false
  },
  getters: {
      getPageData (state) {
          return state.pageData
      }
  },
  mutations: {
    SET_PAGE_DATA (state, payload) {
      state.pageData = payload;
    },
    SET_LOADER (state, payload) {
      state.loading = payload;
    }
  }
});

export default store;


// WEBPACK FOOTER //
// ./template/accueil/js/store.js